import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGcp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 12,
	viewBox: "0 0 16 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1239 3.31321H10.5825L11.8562 2.01401L11.9071 1.45357C9.56349 -0.635327 5.99707 -0.457006 3.88269 1.88664C3.85722 1.91211 3.83174 1.93759 3.80627 1.96306C3.22036 2.65087 2.81277 3.44058 2.5835 4.30671C2.73634 4.25576 2.88919 4.23029 3.04204 4.28124L5.58948 3.84817C5.58948 3.84817 5.71685 3.6189 5.79327 3.64437C6.88867 2.37065 8.82473 2.21781 10.1239 3.31321Z",
			fill: "#EA4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6648 4.30675C13.3591 3.21135 12.7732 2.21785 11.9325 1.45361L10.1493 3.2623C10.9135 3.89916 11.3466 4.84171 11.3211 5.83521V6.16638C12.2127 6.16638 12.926 6.90514 12.926 7.79674C12.926 8.66287 12.2127 9.37616 11.3211 9.40163H8.11136L7.80566 9.7328V11.6689L8.11136 12H11.2957C13.6138 12 15.4735 10.1404 15.4735 7.82222C15.4989 6.42112 14.8111 5.09646 13.6648 4.30675Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.92716 11.9745H8.11146V9.40163H4.92716C4.69789 9.40163 4.46862 9.35068 4.26482 9.24878L3.80628 9.40163L2.53256 10.7008L2.43066 11.1594C3.14395 11.6943 4.01008 12 4.92716 11.9745Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.92692 3.56787C2.60875 3.61882 0.774592 5.50393 0.800067 7.8221C0.800067 9.12129 1.41145 10.3441 2.43043 11.1338L4.29006 9.24867C3.47488 8.86655 3.11824 7.924 3.50036 7.10881C3.857 6.31911 4.77408 5.93699 5.58926 6.29363H5.61473C5.97137 6.44648 6.25159 6.75217 6.40444 7.10881L8.26407 5.22371C7.44889 4.17926 6.22612 3.56787 4.92692 3.56787Z",
			fill: "#FBBC05"
		})
	]
});
export default SvgGcp;
